import { BLOCKS_CSS, BLOCKS_TEMPLATE_ID, paginateBlocks, renderBlocks } from '../blocks.js';
import type { MenuTemplate } from './common.js';

/**
 * "Build your own": the board's own grid of blocks, laid out in the board editor (see
 * `blocks.ts`). Without a layout it shows photo cards for every item.
 */
export const buildYourOwn: MenuTemplate = {
  id: BLOCKS_TEMPLATE_ID,
  name: 'Build your own',
  description: 'Drag ready-made cards, lists, headings and pictures into a grid of 1 to 6 columns.',
  defaultTheme: {
    backgroundColor: '#14110f',
    surfaceColor: '#231e1a',
    textColor: '#f5efe6',
    primaryColor: '#ffffff',
    accentColor: '#f4a62a',
    fontId: 'modern',
    backgroundMediaId: null,
  },
  variants: [
    { id: 'ember', name: 'Ember', theme: {} },
    { id: 'paper', name: 'Paper', theme: { backgroundColor: '#f6f1e7', surfaceColor: '#ffffff', textColor: '#2b2620', primaryColor: '#1d1914', accentColor: '#c2410c' } },
    { id: 'ocean', name: 'Ocean', theme: { backgroundColor: '#0b1e2d', surfaceColor: '#12314a', textColor: '#e8f1f8', primaryColor: '#ffffff', accentColor: '#38bdf8' } },
    { id: 'olive', name: 'Olive', theme: { backgroundColor: '#1f2419', surfaceColor: '#2d3424', textColor: '#f1f3e8', primaryColor: '#ffffff', accentColor: '#c5d86d' } },
  ],
  cuisines: ['burgers', 'pizza', 'pasta', 'cafe', 'drinks'],
  uses: { featured: false, sectionImages: false, brand: true, decorations: [] },
  paginate: paginateBlocks,
  render: renderBlocks,
  css: BLOCKS_CSS,
};
